import React, { useState, useCallback } from 'react'
import { Tabs } from 'antd'
import { DashboardOutlined, ThunderboltOutlined, FileTextOutlined, NotificationOutlined, WarningOutlined } from '@ant-design/icons'
import AccountInteractionList from './interaction/AccountInteractionList'
import AccountMonitorTab from './monitor/AccountMonitorTab'
import PlayVelocityTab from './monitor/PlayVelocityTab'
import WorksMonitorTab from './monitor/WorksMonitorTab'
import PlatformNotifyTab from './monitor/PlatformNotifyTab'
import ViolationWorksTab from './monitor/ViolationWorksTab'

const tabDefs = [
  { key: 'account', label: '账号监控', icon: <DashboardOutlined /> },
  { key: 'play', label: '播放流速', icon: <ThunderboltOutlined /> },
  { key: 'works', label: '作品监控', icon: <FileTextOutlined /> },
  { key: 'notify', label: '平台通知', icon: <NotificationOutlined /> },
  { key: 'violation', label: '违规作品', icon: <WarningOutlined /> }
]

export default function MonitorPage() {
  const [activeTab, setActiveTab] = useState('account')
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [selectedIds, setSelectedIds] = useState([])

  const handleSelectAccount = useCallback((acc) => {
    setSelectedAccount(acc)
    setSelectedIds(prev => prev.includes(acc.account_id) ? prev : [...prev, acc.account_id])
  }, [])

  const handleToggleSelect = useCallback((id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])
  }, [])

  const tabContent = {
    account: <AccountMonitorTab />,
    play: <PlayVelocityTab selectedAccount={selectedAccount} />,
    works: <WorksMonitorTab selectedAccount={selectedAccount} />,
    notify: <PlatformNotifyTab selectedAccount={selectedAccount} />,
    violation: <ViolationWorksTab selectedAccount={selectedAccount} />
  }

  return (
    <div style={{ flex: 1, height: '100%', display: 'flex', overflow: 'hidden' }}>
      <div style={{ width: 270, flexShrink: 0 }}>
        <AccountInteractionList
          onSelect={handleSelectAccount}
          selectedIds={selectedIds}
          onToggleSelect={handleToggleSelect}
        />
      </div>

      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#f5f6fa' }}>
        <div style={{ background: '#fff', borderBottom: '1px solid #e8e8e8', padding: '0 16px', flexShrink: 0 }}>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={tabDefs}
            size="small"
            style={{ marginBottom: 0 }}
          />
        </div>
        <div style={{ flex: 1, overflow: 'auto' }}>
          {tabContent[activeTab]}
        </div>
      </div>
    </div>
  )
}
